import React, { useEffect, useState } from "react";
import "./LoginPage.css";
import translateLogo from "../../assets/img/engage_translate_logo.svg";
import transcribeLogo from "../../assets/img/engage_transcribe_logo.svg";
import { useNavigate } from "react-router";
import { Auth, Hub } from "aws-amplify";
import { FederatedEngageAIProvider } from "../../constant/constant";
import { isUserLoggedIn } from "../../services/auth/AuthAPI";
import { Spin } from "antd";
import LoginTranslateInfoGraphicImg from "../../assets/img/wl-engage-translate-splashpg.png";
import LoginTranscriptInfoGraphicImg from "../../assets/img/wl-engage-transcribe-splashpg.png";

interface LoginPageProps {}

function LoginPage(props: LoginPageProps) {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    localStorage.clear();
  }, []);
  useEffect(() => {
    Hub.listen("auth", (data) => {
      switch (data.payload.event) {
        case "signIn":
          localStorage.setItem("cognitoUser", "true");
          localStorage.setItem("isAuthenticated", "true");
          // Auth.currentSession().then((res) => {
          //   localStorage.setItem("userData", JSON.stringify(res.getIdToken().payload));
          //   setLoading(false);

          //   navigate("/auth/documents");
          // });
          // setLoading(false);

          break;
        case "signIn_failure":
          // setLoading(false);
          setLoading(false);

          break;
        default:
          // setLoading(false);
          setLoading(false);

          break;
      }
    });
  });

  const federatedLogin = async () => {
    setLoading(true);
    // localStorage.setItem("idpLogin", true);

    await Auth.federatedSignIn({ provider: FederatedEngageAIProvider });
  };
  // if (loading) {
  //   return (
  //     <div
  //       className="app"
  //       style={{ textAlign: "center", display: "flex", alignItems: "center", justifyContent: "center" }}>
  //       <Spin size="large" />
  //     </div>
  //   );
  // }
  return (
    <Spin spinning={loading}>
      <div className="login-main-container">
        <div className="login-container">
          <div className="login-img-container">
            <img
              src={LoginTranslateInfoGraphicImg}
              className="login-img"
              alt="translate"
              onClick={() => {
                federatedLogin();
              }}
            />
          </div>
          <img
            src={translateLogo}
            className="login-title"
            alt="translate-title"
          />
        </div>
        <div className="login-container">
          <div className="login-img-container">
            <img
              src={LoginTranscriptInfoGraphicImg}
              className="login-img"
              alt="transcribe"
              // onClick={() => {
              //   federatedLogin();
              // }}
            />
          </div>
          <img
            src={transcribeLogo}
            className="login-title"
            alt="transcribe-title"
          />
        </div>
      </div>
    </Spin>
  );
}

export default LoginPage;
